import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API, withCredentials: true });

export const Auth = {
  me: () => api.get("/auth/me").then(r => r.data),
  session: (sessionId) => api.post("/auth/session", null, { headers: { "X-Session-ID": sessionId } }).then(r => r.data),
  logout: () => api.post("/auth/logout").then(r => r.data),
};

export const Prospects = {
  list: (params = {}) => api.get("/prospects", { params }).then(r => r.data),
  get: (id) => api.get(`/prospects/${id}`).then(r => r.data),
  create: (data) => api.post("/prospects", data).then(r => r.data),
  update: (id, data) => api.patch(`/prospects/${id}`, data).then(r => r.data),
  remove: (id) => api.delete(`/prospects/${id}`).then(r => r.data),
  importCsv: (file) => {
    const fd = new FormData(); fd.append("file", file);
    return api.post("/prospects/import-csv", fd, { headers: { "Content-Type": "multipart/form-data" }}).then(r => r.data);
  },
  scrape: (data) => api.post("/prospects/scrape", data).then(r => r.data),
  enrich: (id) => api.post(`/prospects/${id}/enrich`).then(r => r.data),
  markReplied: (id, note) => api.post("/prospects/mark-replied", { prospect_id: id, note }).then(r => r.data),
  importLinkedIn: (url, pasted_text) => api.post("/prospects/import-linkedin", { url, pasted_text }).then(r => r.data),
};

export const Campaigns = {
  list: () => api.get("/campaigns").then(r => r.data),
  create: (data) => api.post("/campaigns", data).then(r => r.data),
  remove: (id) => api.delete(`/campaigns/${id}`).then(r => r.data),
  generateVariants: (id, data = {}) => api.post(`/campaigns/${id}/generate-variants`, data).then(r => r.data),
  variantStats: (id) => api.get(`/campaigns/${id}/variant-stats`).then(r => r.data),
};

export const Replies = {
  draft: (prospect_id, inbound_message_id) => api.post("/replies/draft-response", { prospect_id, inbound_message_id }).then(r => r.data),
};

export const MapAPI = {
  prospects: () => api.get("/map/prospects").then(r => r.data),
};

export const Messages = {
  list: (params = {}) => api.get("/messages", { params }).then(r => r.data),
  create: (data) => api.post("/messages", data).then(r => r.data),
  send: (id) => api.post(`/messages/${id}/send`).then(r => r.data),
  remove: (id) => api.delete(`/messages/${id}`).then(r => r.data),
  update: (id, data) => api.patch(`/messages/${id}`, data).then(r => r.data),
};

export const AI = {
  draft: (data) => api.post("/ai/draft", data).then(r => r.data),
};

export const Appointments = {
  list: () => api.get("/appointments").then(r => r.data),
  get: (id) => api.get(`/appointments/${id}`).then(r => r.data),
  create: (data) => api.post("/appointments", data).then(r => r.data),
  remove: (id) => api.delete(`/appointments/${id}`).then(r => r.data),
  icsUrl: (id) => `${API}/appointments/${id}/ics`,
};

export const Stats = {
  get: () => api.get("/stats").then(r => r.data),
};

export const Settings = {
  get: () => api.get("/settings").then(r => r.data),
  update: (data) => api.put("/settings", data).then(r => r.data),
};

export const FollowUps = {
  schedule: (prospect_id, campaign_id) => api.post("/followups/schedule", { prospect_id, campaign_id }).then(r => r.data),
  dispatchNow: () => api.post("/followups/dispatch-now").then(r => r.data),
};

export const Public = {
  info: () => api.get("/public/booking-info").then(r => r.data),
  book: (data) => api.post("/public/book", data).then(r => r.data),
};

export const Users = {
  list: () => api.get("/users").then(r => r.data),
  create: (data) => api.post("/users", data).then(r => r.data),
  remove: (id) => api.delete(`/users/${id}`).then(r => r.data),
  assign: (prospect_id, user_id) => api.post(`/prospects/${prospect_id}/assign`, { user_id }).then(r => r.data),
  roundRobin: () => api.post("/prospects/round-robin").then(r => r.data),
};

export const Rules = {
  list: () => api.get("/assignment-rules").then(r => r.data),
  create: (data) => api.post("/assignment-rules", data).then(r => r.data),
  remove: (id) => api.delete(`/assignment-rules/${id}`).then(r => r.data),
};

export const Sessions = {
  list: () => api.get("/sessions").then(r => r.data),
  revoke: (token_id) => api.delete(`/sessions/${token_id}`).then(r => r.data),
};
